<mat-sidenav-container class="sidebar-container"
                       autosize>
    <div class="vh-100 overflow-hidden sidebar-main sidebar-navy-background"
         [ngStyle]="{'width':isExpanded?'275px': !isShowing?'auto':'275px'}">
        <mat-sidenav #sidenav
                     class="sidebar-sidenav"
                     mode="side"
                     opened="true"
                     (mouseenter)="mouseenter()"
                     (mouseleave)="mouseleave()">
            <mat-nav-list>
                <mat-list-item class="py-3 sidebar-navy-background mt-5">
                    <button class="btn btn-primary sidebar-add-button font-weight-bold"
                            (click)="createNewTask()"
                            *ngIf="isExpanded || isShowing">+
                        Novi zadatak
                    </button>
                    <mat-icon (click)="createNewTask()"
                              *ngIf="!isExpanded && !isShowing"
                              mat-list-icon
                              color="accent"
                    class="ml-2">
                        add_circle
                    </mat-icon>
                </mat-list-item>


                <mat-list-item class="sidebar-app-home-menu-item"
                               (click)="navigateTo('/home')"
                               [ngClass]="{'ml-1': !isExpanded && !isShowing}">
                    <span *ngIf="isExpanded || isShowing">
                        Radni sto
                    </span>
                    <mat-icon *ngIf="isExpanded || isShowing" mat-list-icon>desktop_windows</mat-icon>
                    <mat-icon *ngIf="!isExpanded && !isShowing" mat-list-icon color="accent">desktop_windows</mat-icon>
                </mat-list-item>

                <div *ngIf="loader === false;">
                    <div
                         *ngFor="let item of menuItems; index as i ">
                        <div *ngFor="let menu of item.data;index as ind">
                            <mat-list-item class="sidebar-menu-item parent mt-2"
                                           (click)="navigateTo(menu.link)"
                                           [ngClass]="{'ml-1': !isExpanded && !isShowing}">
                            <span *ngIf="isExpanded || isShowing">
                                {{menu.title}}
                            </span>
                                <mat-icon mat-list-icon>
                                    {{menu.icon}}
                                </mat-icon>
                                <mat-icon class="sidebar-menu-button"
                                          (click)="showSubmenu = !showSubmenu;"
                                          [ngClass]="{'rotated' : showSubmenu}"
                                          *ngIf="(isExpanded || isShowing) && menu.submenu">
                                    expand_more
                                </mat-icon>
                            </mat-list-item>
                            <div class="sidebar-submenu"
                                 [ngClass]="{'expanded' : showSubmenu}"
                                 *ngIf="(isShowing || isExpanded) && menu.submenu">
                                <a *ngFor="let subItem of menu.submenuItems"
                                   mat-list-item
                                   (click)="subitemHandler(subItem)">
                                    <mat-icon *ngIf="subItem.hasFunction===true"
                                              mat-list-icon>
                                        add_to_photos
                                    </mat-icon>
                                    {{subItem.name}}
                                </a>
                            </div>
                        </div>
                    </div>

                </div>

            </mat-nav-list>
        </mat-sidenav>
    </div>
</mat-sidenav-container>
